module.exports = __webpack_public_path__ + "media/images/icons/book-icon-40818697207478bfa3b59005afdf2705.svg";